import { ShareDeliveryItem } from '@features/share';
import { Clip } from '../types';

export const mapClipToShareableItem = (clip: Clip): ShareDeliveryItem => {
    return {
        id: parseInt(clip.id, 10),
        name: clip.clipName,
        hasProxy: clip.hasProxy,
        isValid: clip.hasProxy,
    };
};
